import { useEffect } from 'react';
import { guid } from '@bydesign-ui/utils';
import { useRefGetter, useSingleton } from '@bydesign-ui/hooks';
import { useFormScope } from '../../../hooks/form';
import { useForm } from './useForm';
export function useWatch(keys, fn) {
  var lazy = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var form = useForm();
  var scope = useFormScope();
  var id = useSingleton(function () {
    return guid();
  });
  var getter = useRefGetter(fn);
  useEffect(function () {
    var callback = function callback(changes, flags) {
      var fn = getter();
      fn(form, changes, flags);
    };

    form.watch(id, scope, keys, callback, lazy);
    return function () {
      return form.unwatch(id);
    };
  }, keys);
}